import React, {useMemo} from 'react';
import moment from "moment/moment";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {getTeamShortName} from "../../../utils/SportUtils";
import {useGetNHLPlayerGamesStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";
import NHLSeasonStats from "./NHLSeasonStats";

import './NHLGamesStats.style.scss'
import {getCurrentSeasonYearsBySportAndSeason} from "../../../constants/SportsConst";
import "../PlayerGamesStats.style.scss";

const NHLGamesStats = ({contest}) => {
    const player = contest.player;
    const seasonYears = getCurrentSeasonYearsBySportAndSeason(1);
    const queryArgs = useMemo(() => ({
        playerId: player.PlayerId,
        from: moment().add(-1, 'weeks').toDate().getTime(),
        to: moment().add(1, 'days').endOf('day').toDate().getTime(),
        teamId: player.TeamId
    }), [player.PlayerId, player.TeamId]);

    const {data: gameStats, isLoading} = useGetNHLPlayerGamesStatsByPlayerIdQuery(queryArgs);

    if (!gameStats)
        return <div className={"NoStats"}>No Stats Available</div>

    let isGoalie = gameStats.map((game) => game.hasOwnProperty("GoalsAgainst")).includes(true);

    return <>
        <NHLSeasonStats playerId={player.PlayerId}
                        seasonYears={seasonYears} />
        <div className="NHLgameLogSection">
            <Typography variant="h6" className="gameLogTitle">
                {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.seasonStats"}/>
            </Typography>
            <div className="NHLGamesStatsLog">
                <React.Fragment>
                    <div className="GameStats">
                        <div className="tableContainer">
                            {/* todo: put this into a Component: NHLGamesStatsTable */}
                            <table className={"gameLogTable"}>
                                <thead>
                                <tr>
                                    <th>Date vs Opp</th>
                                    <th>G</th>
                                    <th>A</th>
                                    <th className={ contest.StatsKey === "SOG" ? "highlight gold-gradient-text" : ""}>SOG</th>
                                    <th>SHG</th>
                                    {!isGoalie &&
                                        <React.Fragment>
                                            <th>BkS</th>
                                            <th>SG</th>
                                            <th>HT</th>
                                        </React.Fragment>}
                                    {isGoalie &&
                                        <React.Fragment>
                                            <th>GA</th>
                                            <th className={ contest.StatsKey === "Saves" ? "highlight gold-gradient-text" : ""}>SV</th>
                                            <th>SO</th>
                                            <th>W</th>
                                        </React.Fragment>}
                                </tr>
                                </thead>
                                {gameStats?.filter((game) => moment(game.DateTime).isBefore(moment(), 'day'))
                                    .sort((a, b) => moment(a.DateTime).isBefore(moment(b.DateTime)) ? 1 : -1)
                                    .map((gameStats) => {

                                        if (!gameStats)
                                            return null;

                                        return <tbody key={gameStats.GameId}>
                                        <tr>
                                            {
                                                <React.Fragment>
                                                    <td><span
                                                        className="date">{moment(gameStats.DateTime).format("MM/DD")}</span>
                                                        <span
                                                            className="vs"> vs {getTeamShortName(gameStats.Opponent, "NHLPlayer")} </span>
                                                    </td>
                                                    <td>{gameStats.Goals}</td>
                                                    <td>{gameStats.Assists}</td>
                                                    <td className={ contest.StatsKey === "SOG" ? "highlight gold-gradient-text" : ""}>{gameStats.Shots}</td>
                                                    <td>{gameStats.ShortHandedGoals}</td>
                                                    {!isGoalie &&
                                                        <React.Fragment>
                                                            <td>{gameStats.BlockedShots}</td>
                                                            <td>{gameStats.ShootoutGoals}</td>
                                                            <td>{gameStats.HatTricks}</td>
                                                        </React.Fragment>}
                                                    {isGoalie &&
                                                        <React.Fragment>
                                                            <td>{gameStats.GoalsAgainst}</td>
                                                            <td className={ contest.StatsKey === "Saves" ? "highlight gold-gradient-text" : ""}>{gameStats.Saves}</td>
                                                            <td>{gameStats.Shutouts}</td>
                                                            <td>{gameStats.Wins}</td>
                                                        </React.Fragment>}
                                                </React.Fragment>
                                            }
                                        </tr>
                                        </tbody>
                                    })}
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        </div>
    </>
}

export default NHLGamesStats;